// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1IRoD","validationTips":"StatementDescriptor_validationTips__2fpzM"};